import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { getNFTToken } from 'modules/ownerPanel/methods/getNFTToken';

interface IGetOwnerPoolAddressesArgs {
  poolAddress: Address;
}

export const {
  useGetNFTTokenQuery,
  endpoints: { getNFTToken: getNFTTokenEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getNFTToken: build.query<Address, IGetOwnerPoolAddressesArgs>({
      queryFn: async ({ poolAddress }) => {
        try {
          const client = getPublicClient();

          return {
            data: await getNFTToken(client, {
              poolAddress,
            }),
          };
        } catch {
          const client = getPublicClient();

          return {
            data: await getNFTToken(client, {
              poolAddress,
            }),
          };
        }
      },
      providesTags: [cacheTags.pools, cacheTags.account],
    }),
  }),
});
